import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-cand-res-log',
  templateUrl: './bulk-cand-res-log.component.html',
  styleUrls: ['./bulk-cand-res-log.component.scss']
})
export class BulkCandResLogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
